/**
 * Motion helpers for the operator-UI animations (ANIMATIONS.md, phase C).
 *
 * Every animated background (auth particles, kinetic grid, dotted globe, ASCII
 * band) checks prefersReducedMotion() once at mount: when the OS asks for
 * reduced motion they draw ONE static frame and never start a rAF loop.
 */
import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

export function prefersReducedMotion() {
  try {
    return typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(QUERY).matches;
  } catch {
    return false;
  }
}

/** React hook form of prefersReducedMotion(); follows OS changes live. */
export function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(prefersReducedMotion);
  useEffect(() => {
    let mql;
    try {
      mql = window.matchMedia ? window.matchMedia(QUERY) : null;
    } catch {
      mql = null;
    }
    if (!mql) return undefined;
    const on = () => setReduced(mql.matches);
    if (mql.addEventListener) mql.addEventListener("change", on);
    else if (mql.addListener) mql.addListener(on);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", on);
      else if (mql.removeListener) mql.removeListener(on);
    };
  }, []);
  return reduced;
}
